import { ComponentProps, FC, forwardRef } from 'react'
import { styled } from '../../../../lib/stitches'
import { Search as SearchIcon } from '../../../core/icons/responsive-icons'

const Fieldset = styled('fieldset', {
  all: 'unset',
  display: 'block',
  position: 'relative'
})

const Search = styled(SearchIcon, {
  strokeWidth: '1.2px',
  position: 'absolute',
  left: '12px',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '16px',
  height: '16px',
  userSelect: 'none',
  color: '$gray06'
})

const Input = styled('input', {
  all: 'unset',
  width: '100%',
  borderRadius: '9999px',
  display: 'block',
  padding: '12px',
  background: 'rgba(0,0,0,0.03)',
  paddingLeft: '36px',
  boxSizing: 'border-box',
  fontSize: '14px',
  lineHeight: '16px',
  color: '$black',
  '&::placeholder': {
    color: '$gray06'
  }
})

const SearchBar: FC<ComponentProps<typeof Input>> = forwardRef(({ css, ...props }, ref) => (
  <Fieldset css={css}>
    <Input type={'text'} placeholder="Search" ref={ref} {...props} />
    <Search />
  </Fieldset>
))

export default SearchBar
